// import React, { useMemo } from "react";
// import { Link } from "react-router-dom";
// import { useProducts } from "../../context/ProductContext";
// import work1 from "../../assets/img/work-1.jpg";
// import work2 from "../../assets/img/work-2.jpg";
// import work3 from "../../assets/img/work-3.jpg";
// import work4 from "../../assets/img/work-4.jpg";
// import work5 from "../../assets/img/work-5.jpg";
// import work6 from "../../assets/img/work-6.jpg";
// import work7 from "../../assets/img/work-7.jpg";
// import work8 from "../../assets/img/work-8.jpg";
// import work9 from "../../assets/img/work-9.jpg";
// import work10 from "../../assets/img/work-10.jpg";
// import work11 from "../../assets/img/work-11.jpg";
// import work12 from "../../assets/img/work-12.jpg";
// import "./Category.css";

// const fallbackImages = [
//   work1,
//   work2,
//   work3,
//   work4,
//   work5,
//   work6,
//   work7,
//   work8,
//   work9,
//   work10,
//   work11,
//   work12,
// ];

// const Category = () => {
//   const { categories, products, loading } = useProducts();

//   const flatCourses = useMemo(() => {
//     if (!products?.length) return [];
//     return products.flatMap((cat) =>
//       (cat.courses || []).map((course) => ({
//         ...course,
//         category_name: cat.category_name,
//       })),
//     );
//   }, [products]);

//   const categoryData = useMemo(() => {
//     if (!categories?.length) return [];

//     return categories
//       .filter((cat) => cat !== "All")
//       .map((catName, index) => {
//         const count = flatCourses.filter(
//           (c) => c.category_name === catName,
//         ).length;

//         return {
//           title: catName,
//           countNumber: count,
//           count: `${count} Courses`,
//           image: fallbackImages[index % fallbackImages.length],
//         };
//       })
//       .sort((a, b) => b.countNumber - a.countNumber); 
//   }, [categories, flatCourses]);

//   if (loading) {
//     return (
//       <section className="ftco-section">
//         <div className="container text-center py-5">Loading categories...</div>
//       </section>
//     );
//   }

//   return (
//     <section className="ftco-section">
//       <div className="container">
//         <div className="row justify-content-center pb-4">
//           <div className="col-md-12 heading-section text-center ftco-animate">
//             <span className="subheading">Start Learning Today</span>
//             <h2 className="mb-4">Browse Online Course Category</h2>
//           </div>
//         </div>

//         <div className="row justify-content-center">
//           {categoryData.map((cat, i) => (
//             <div
//               className="col-md-4 col-lg-2 d-flex justify-content-center"
//               key={i}
//             >
//               <Link
//                 to={`/courses?category=${encodeURIComponent(cat.title)}`}
//                 style={{ textDecoration: "none" }}
//               >
//                 <div
//                   className="course-category img d-flex align-items-center justify-content-center"
//                   style={{ backgroundImage: `url(${cat.image})` }}
//                 >
//                   <div className="text w-100 text-center">
//                     <h3>{cat.title}</h3>
//                     <span>{cat.count}</span>
//                   </div>
//                 </div>
//               </Link>
//             </div>
//           ))}

//           <div className="col-md-12 text-center mt-4">
//             <Link to="/courses" className="btn btn-secondary">
//               See All Courses
//             </Link>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Category;
import React, { useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { useProducts } from "../../context/ProductContext";
import work1 from "../../assets/img/work-1.jpg";
import work2 from "../../assets/img/work-2.jpg";
import work3 from "../../assets/img/work-3.jpg";
import work4 from "../../assets/img/work-4.jpg";
import work5 from "../../assets/img/work-5.jpg";
import work6 from "../../assets/img/work-6.jpg";
import work7 from "../../assets/img/work-7.jpg";
import work8 from "../../assets/img/work-8.jpg";
import work9 from "../../assets/img/work-9.jpg";
import work10 from "../../assets/img/work-10.jpg";
import work11 from "../../assets/img/work-11.jpg";
import work12 from "../../assets/img/work-12.jpg";
import "./Category.css";

const fallbackImages = [
  work1,
  work2,
  work3,
  work4,
  work5,
  work6,
  work7,
  work8,
  work9,
  work10,
  work11,
  work12,
];

const Category = () => {
  const { categories, products, loading } = useProducts();
  const scrollContainerRef = useRef(null);

  const flatCourses = useMemo(() => {
    if (!products?.length) return [];
    return products.flatMap((cat) =>
      (cat.courses || []).map((course) => ({
        ...course,
        category_name: cat.category_name,
      })),
    );
  }, [products]);

  const categoryData = useMemo(() => {
    if (!categories?.length) return [];

    return categories
      .filter((cat) => cat !== "All")
      .map((catName, index) => {
        const count = flatCourses.filter(
          (c) => c.category_name === catName,
        ).length;

        return {
          title: catName,
          countNumber: count,
          count: `${count} Courses`,
          image: fallbackImages[index % fallbackImages.length],
        };
      })
      .sort((a, b) => b.countNumber - a.countNumber);
  }, [categories, flatCourses]);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 240;
      const currentScroll = scrollContainerRef.current.scrollLeft;
      const targetScroll = direction === "left" 
        ? currentScroll - scrollAmount 
        : currentScroll + scrollAmount;
      
      scrollContainerRef.current.scrollTo({
        left: targetScroll,
        behavior: "smooth",
      });
    }
  };

  if (loading) {
    return (
      <section className="ftco-section">
        <div className="container text-center py-5">Loading categories...</div>
      </section>
    );
  }

  return (
    <section className="ftco-section category-section">
      <div className="container-fluid px-5">
        <div className="row justify-content-center pb-5">
          <div className="col-md-12 heading-section text-center ftco-animate">
            <span className="subheading">Start Learning Today</span>
            <h2 className="mb-4">Browse Online Course Category</h2>
          </div>
        </div>

        <div className="category-slider-wrapper">
          {categoryData.length > 6 && (
            <button
              className="category-nav-btn category-nav-prev"
              onClick={() => scroll("left")}
              aria-label="Previous categories"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
          )}

          <div className="category-slider-container" ref={scrollContainerRef}>
            <div className="category-slider-track">
              {categoryData.map((cat, i) => (
                <div className="category-slide" key={i}>
                  <Link
                    to={`/courses?category=${encodeURIComponent(cat.title)}`}
                    className="category-link"
                  >
                    <div
                      className="course-category"
                      style={{ backgroundImage: `url(${cat.image})` }}
                    >
                      <div className="category-overlay"></div>
                      <div className="text">
                        <h3>{cat.title}</h3>
                        <span>{cat.count}</span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>

          {categoryData.length > 6 && (
            <button
              className="category-nav-btn category-nav-next"
              onClick={() => scroll("right")}
              aria-label="Next categories"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          )}
        </div>

        <div className="row">
          <div className="col-md-12 text-center mt-5">
            <Link to="/courses" className="btn btn-secondary">
              See All Courses
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Category;